<template>
  <el-dialog
    class="bankImportDialog"
    title="题库导入"
    top="5vh"
    :visible.sync="bankImportVisible"
    width="960px"
    :close-on-click-modal="false"
  >
    <table-list
      v-if="bankImportVisible"
      :search-form="searchForm(this)"
      :data="storeList"
      :columns="columns(this)"
      :pager="pager"
      :options="{ selection: true, reserveSelection: true, rowKey: 'questionStoreId', pageSize: [10, 20, 50] }"
      @search="onSearch"
      @selectionChange="handleSelectionChange"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    ></table-list>
    <div class="footer">
      <el-button @click="bankImportVisible = false">取消</el-button>
      <el-button type="primary" :loading="saveLoading" @click="save">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
// 试题类型
const questionTypeMap = {
  1: '单选题',
  2: '多选题',
  3: '计算题',
  4: '判断题',
  5: '填空题',
  6: '简答题',
  7: '论述题',
  8: '案例分析题',
  9: '综合题',
}
// 搜索框配置
const searchForm = () => [
  {
    label: '题库名称',
    prop: 'questionStoreName',
  },
]
// 表格列配置
const columns = _this => [
  {
    prop: 'questionStoreName',
    label: '题库名称',
    minWidth: 200,
  },
  {
    prop: 'questionTypeMuster',
    label: '试题包含类型',
    minWidth: 200,
    formatter: row => _this.formatQuestionTypes(row.questionTypeMuster),
  },
  {
    prop: 'questionNum',
    label: '题目数量',
    minWidth: 100,
  },
  {
    prop: 'createTime',
    label: '创建时间',
    minWidth: 150,
  },
]
import TableList from '@/components/TableList'
import { questionStorePage, paperImportFromStore } from '@/api/exam'
import to from 'await-to'
export default {
  name: 'BankImportDialog',
  components: { TableList },
  data() {
    return {
      searchForm,
      columns,
      bankImportVisible: false,
      paperId: '',
      storeList: [],
      selectStoreList: [],
      queryParams: {},
      saveLoading: false,
      pager: {
        total: 0,
        size: 20,
        current: 1,
      },
    }
  },
  methods: {
    show(paperId) {
      this.paperId = paperId
      this.selectStoreList = []
      this.queryParams = {}
      this.pager.current = 1
      this.bankImportVisible = true
      this.getStoreList()
    },
    formatQuestionTypes(value) {
      if (!value) return '-'
      return String(value)
        .split(',')
        .map(item => questionTypeMap[item] || item)
        .join(',')
    },
    async getStoreList() {
      const { current, size } = this.pager
      const [res, err] = await to(questionStorePage({ current, size, ...this.queryParams }))
      if (err) return this.$message.warning(err.msg)
      this.storeList = res.data.list
      this.pager.total = res.data.total
    },
    handleSelectionChange(val) {
      this.selectStoreList = val
    },
    // 查询按钮
    onSearch(queryParams) {
      this.pager.current = 1
      this.queryParams = queryParams
      this.getStoreList()
    },
    // 分页
    handleSizeChange(size) {
      this.pager.current = 1
      this.pager.size = size
      this.getStoreList()
    },
    handleCurrentChange(current) {
      this.pager.current = current
      this.getStoreList()
    },
    async save() {
      if (!this.selectStoreList.length) return this.$message.warning('请选择要导入的题库')
      this.saveLoading = true
      const [, err] = await to(
        paperImportFromStore({
          paperId: this.paperId,
          storeIdList: this.selectStoreList.map(item => item.questionStoreId),
          isCover: false,
        }),
      )
      this.saveLoading = false
      if (err) return this.$message.warning(err.msg)
      this.bankImportVisible = false
      this.$message.success('导入成功')
      this.$emit('success')
    },
  },
}
</script>
<style lang="scss" scoped>
.bankImportDialog {
  /deep/ .el-table__body-wrapper {
    height: calc(100% - 102px) !important;
  }
  .footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-top: 16px;
    .el-button + .el-button {
      margin-left: 12px;
    }
  }
}
</style>
